import { lazyLoad } from "./LazyLoad";

// @TODO move it into config file
const GoogleMapsSrc = "https://maps.googleapis.com/maps/api/js?v=3&callback=_cmsGoogleMapsLoaded&libraries=places&key=AIzaSyCL16T3evFhuQOfX2a9Wtv7u7hfcTSGnGY";
function isGoogleScriptMapLoaded() {
  let scripts = document.getElementsByTagName("script");
  let google_already_added = false;
  let length = scripts.length;

  //check each script element. if google maps is not among them, flag it to be loaded
  for (let i = 0; i < length; i++) {
    if (scripts[i].src.indexOf(GoogleMapsSrc) === 0) {
      google_already_added = true;
      break;
    }
  }
  return google_already_added;
}
function loadGoogleMaps(cb) {
  if (isGoogleScriptMapLoaded() === true) {
    cb && cb();
    return;
  }
  let googleMaps = document.createElement("script");
  googleMaps.src = GoogleMapsSrc;
  googleMaps.onreadystatechange = googleMaps.onload = function () {
    cb && cb();
  };
  document.head.appendChild(googleMaps);
}
function initMap(mapEl, attributes) {
  let mapObj = null;
  if (attributes.routePlanner) {
    return;
  }
  createMapElement();

  /**
   * Entry point to creating map element
   */
  function createMapElement() {
    parseCustomStyles();
    if (attributes.lat && attributes.lng) {
      if (attributes.streetview) {
        createStreetView();
      } else {
        createMap();
      }
    } else {
      var request = {
        query: attributes.address
      };
      //make a request to google places api to get lat & lng from the searched text query
      // the callback is a function that would create the map
      var service = new google.maps.places.PlacesService(mapEl);
      service.textSearch(request, handlePlacesSearch.bind(this));
    }
  }

  /*initMaps
   * checks the response from google places api, and decides whether to create a map or a street view
   * based on the "use streetview" checkbox. This value is set earlier in the setSaveHandler
   */
  function handlePlacesSearch(results, status) {
    //if the status is OK (a result is found), take the lat & lng position of the first result (the most relevant one) and set a street view
    if (status == google.maps.places.PlacesServiceStatus.OK) {
      //if the user chose to use a street view, use it. Else, draw a normal map using the coordinates from google places
      attributes.lat = results[0].geometry.location.lat();
      attributes.lng = results[0].geometry.location.lng();
      if (attributes.streetview) {
        createStreetView();
      } else {
        createMap();
      }
    } else {
      //else query google geocoding api to try and find lat & long from the entered address
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        address: attributes.address
      }, geocodeHandler.bind(this));
    }
  }

  /**
   * Handles geocoding api search by getting the found coordinates and extracting a map
   */
  function geocodeHandler(results, status) {
    if (status == "OK") {
      var position = {};
      attributes.lat = results[0].geometry.location.lat();
      attributes.lng = results[0].geometry.location.lng();

      //if the user chose street view or not
      if (attributes.streetview) {
        createStreetView();
      } else {
        createMap();
      }
    }
  }

  /**
   * Creates a google maps map. Sets this.map to google.maps.Map
   * @param object {lat, lng} position
   */
  function createMap() {
    mapObj = new google.maps.Map(mapEl, {
      center: {
        lat: parseFloat(attributes.lat),
        lng: parseFloat(attributes.lng)
      },
      zoom: parseInt(attributes.zoom, 10),
      scrollwheel: attributes.enableScroll || false,
      styles: attributes.customStyles || []
    });
    var size = attributes.markerSize.split("x");
    var icon = {
      url: attributes.customMarker,
      // url
      scaledSize: new google.maps.Size(size[0], size[1]),
      // scaled size
      origin: new google.maps.Point(0, 0),
      // origin
      anchor: new google.maps.Point(0, 0) // anchor
    };

    //create marker
    var marker = new google.maps.Marker({
      position: new google.maps.LatLng(parseFloat(attributes.lat), parseFloat(attributes.lng)),
      animation: google.maps.Animation.DROP,
      map: mapObj
    });

    //if custom marker is chosen, apply it
    if (attributes.customMarker) {
      marker.setIcon(icon);
    }
    //create marker info window, if necessary
    if (attributes.infoText) {
      var infowindow = new google.maps.InfoWindow({
        content: attributes.infoText
      });
      marker.addListener("click", function () {
        infowindow.open(this.map, marker);
      });
    }
  }

  /**
   * Creates a google maps street view. If this.map is set, attaches the street view to the map
   * @param object {lat, lng} position
   */
  function createStreetView() {
    var panorama = new google.maps.StreetViewPanorama(mapEl, {
      position: attributes,
      pov: {
        heading: 240,
        pitch: 10
      }
    });
    if (mapObj !== null) {
      mapObj.setStreetView(panorama);
    }
  }

  /**
   * Parses custom styles
   */
  function parseCustomStyles() {
    attributes.customStyles = [];

    //based on the custom styles tab, create an object declaring custom styling for google maps. Example:
    //            attributes.customStyles = [
    //                {
    //                    "featureType": "all",
    //                    "elementType": "all",
    //                    "stylers": [
    //                        {"color": "#C0C0C0"}
    //                    ]
    //                },
    //            ]
    //if there have been custom styles added
    if (attributes.extendCount) {
      for (var i = 0; i < attributes.extendCount; i++) {
        //if the current row's checkbox state was set to active - the row is enabled
        if (attributes.googleLineActive && attributes.googleLineActive[i]) {
          //compute features
          var feature = attributes.googleFeatureType1[i];
          if (attributes.googleFeatureType2[i] !== "all") {
            feature += "." + attributes.googleFeatureType2[i];
          }
          if (attributes.googleFeatureType3[i] !== "all") {
            feature += "." + attributes.googleFeatureType3[i];
          }
          //compute elements
          var element = null;
          if (attributes.googleElementType1[i] && attributes.googleElementType1[i] !== "all") {
            element = attributes.googleElementType1[i];
          }
          if (element && attributes.googleElementType2[i] !== "all") {
            element += "." + attributes.googleElementType2[i];
          }
          if (element && attributes.googleElementType3[i] !== "all") {
            element += "." + attributes.googleElementType3[i];
          }
          var tmp = {
            featureType: feature
          };
          //append elements styling if available
          if (element) {
            tmp["elementType"] = element;
          }
          //compute and append stylers
          tmp.stylers = [];
          var tmpStyler = {};
          tmpStyler[attributes.googleStylers[i]] = attributes.googleStyles[i]; //example: 'color': #ffffff
          tmp.stylers.push(tmpStyler);
          attributes.customStyles.push(tmp);
        }
      }
    }
  }
}
function routePlannerOnSubmit(event) {
  const target = event.target;
  target.nextElementSibling.remove();
  target.removeEventListener("submit", routePlannerOnSubmit);
}

/**
 *
 * @param { NodeList | HTMLElement } context
 */
function initMaps(context, options = {}) {
  let mapsElements = [];
  let mapElementSelector = "[data-map-element]";

  // when the context is NodeList
  if (Object.prototype.toString.call(context) === "[object NodeList]") {
    for (let i = 0; i < context.length; i += 1) {
      // find all maps
      let elements = context[i].querySelectorAll(mapElementSelector);

      // convert nodelist to array
      elements = Array.prototype.slice.call(elements);

      // add to the rest ot maps
      mapsElements = mapsElements.concat(elements);
    }
  } else {
    mapsElements = Array.prototype.slice.call(context.querySelectorAll(mapElementSelector));
  }
  if (options.exclude && typeof options.exclude === "function") {
    mapsElements = mapsElements.filter(function (el) {
      // exclude elements that meets the criteria
      return !options.exclude(el);
    });
  }

  // Lazy load all iframe maps
  // ----------------------------------------------------------------------
  const mapLazyLoadEl = context.querySelectorAll("[ data-map-el-lazy-load]");
  for (let i = 0, len = mapLazyLoadEl.length; i < len; i += 1) {
    lazyLoad(mapLazyLoadEl[i], target => {
      let src = target.getAttribute("data-cms-src");

      // only if the map is in lazy mode set its src attribute.
      if (src) {
        target.setAttribute("src", src);
      }
    });
  }

  // Route planner functionality
  // ----------------------------------------------------------------------

  const routePlannerElements = context.querySelectorAll('[data-route-planner] > form[target^="map_frame_"]');
  for (let offset = 0; offset < routePlannerElements.length; offset++) {
    routePlannerElements.item(offset).addEventListener("submit", routePlannerOnSubmit);
  }

  // if no maps elements found, do not load google apis
  if (!mapsElements.length) {
    return;
  }
  mapsElements.forEach(mapEl => {
    lazyLoad(mapEl, target => {
      loadGoogleMaps(() => {
        const attributes = JSON.parse(mapEl.getAttribute("data-map-element-attributes"));
        initMap(target, attributes);
      });
    });
  });
}
const init = function () {
  initMaps(document);
};
export { initMaps, init };